module.exports = __webpack_public_path__ + "02_short_grey.5437b99d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/02_short_grey.png
// module id = m0HS
// module chunks = 0